function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-attention';
export var ID = 'icon-attention';
export var STATUS_COLORS = {
  ERROR: 'error',
  INCOMPLETE: 'incomplete'
};
/* eslint-disable max-len */

export var SVGAttention = function SVGAttention() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    d: "M7.48456658,3.36090834 C7.77384601,2.88522748 8.23615354,2.87419856 8.53214008,3.36090834 L13.8851518,12.1632114 C14.1744312,12.6388923 13.9533381,13.0245078 13.4044521,13.0245078 L2.61225451,13.0245078 C2.05749201,13.0245078 1.83556836,12.6499212 2.13155489,12.1632114 L7.48456658,3.36090834 Z M8,12 C8.55228475,12 9,11.5522847 9,11 C9,10.4477153 8.55228475,10 8,10 C7.44771525,10 7,10.4477153 7,11 C7,11.5522847 7.44771525,12 8,12 Z M7,6 L7,9 L9,9 L9,6 L7,6 Z"
  }));
};
/* eslint-disable max-len */

var Attention = function Attention(props) {
  return React.createElement(Icon, {
    id: ID,
    className: cx(CLASSNAME, _defineProperty({}, "".concat(CLASSNAME, "-").concat(props.status), props.status !== null && props.status !== undefined), props.className),
    onClick: props.onClick,
    svg: SVGAttention
  });
};

Attention.propTypes = {
  status: PropTypes.oneOf([STATUS_COLORS.ERROR, STATUS_COLORS.INCOMPLETE]).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Attention;